import type { JumpChart } from '@shared/jumpChart';
import type { JumpEngineState } from '@shared/engine/jump/state';
import { DEFAULT_KEY_LABEL, SCORE_HUD_X, SCORE_HUD_Y } from './jumpRenderConstants';

/**
 * Paint the corner HUDs: score, combo, "tap X to jump" hint. Score anchors
 * top-LEFT so the leaderboard panel (top-right, above the canvas) never covers
 * it. Combo stacks below the score in the same column.
 */
export function drawJumpHud(
  ctx: CanvasRenderingContext2D,
  chart: JumpChart,
  state: JumpEngineState,
  displayedScore: number,
  canvasHeight: number,
  keyLabel: string,
): void {
  const palette = chart.palette;
  ctx.save();
  ctx.fillStyle = palette.ui;
  ctx.textAlign = 'left';
  ctx.textBaseline = 'top';

  ctx.font = '700 28px "Space Grotesk", system-ui, sans-serif';
  ctx.fillText(formatScore(displayedScore), SCORE_HUD_X, SCORE_HUD_Y);

  ctx.font = '600 18px "Space Grotesk", system-ui, sans-serif';
  ctx.globalAlpha = 0.75;
  ctx.fillText(`Combo x${state.combo}`, SCORE_HUD_X, SCORE_HUD_Y + 36);
  if (state.maxCombo > state.combo) {
    ctx.fillText(`Best x${state.maxCombo}`, SCORE_HUD_X, SCORE_HUD_Y + 60);
  }

  ctx.globalAlpha = 0.55;
  ctx.font = '500 14px "Space Grotesk", system-ui, sans-serif';
  ctx.textBaseline = 'bottom';
  ctx.fillText(
    `Tap ${keyLabel || DEFAULT_KEY_LABEL} for a short hop · hold for a big jump`,
    SCORE_HUD_X,
    canvasHeight - 24,
  );

  ctx.restore();
}

/** Score HUD canvas target — score-pop flyers travel toward it. */
export function getJumpScoreHudTarget(): { x: number; y: number } {
  return { x: SCORE_HUD_X + 56, y: SCORE_HUD_Y + 14 };
}

function formatScore(score: number): string {
  const rounded = Math.round(score);
  if (rounded !== cachedScoreRounded) {
    cachedScoreRounded = rounded;
    cachedScoreText = rounded.toLocaleString('en-US');
  }
  return cachedScoreText;
}

let cachedScoreRounded = -1;
let cachedScoreText = '0';
